import * as React from "react"
import {batch} from "@preact/signals-react";
import {MenuItem} from "@mui/material";

import {appLang} from "../../../../@signals";
import {handleLangPopoverClose} from "./signals";


export default function MaximalLayoutHeaderCountryOption({ lang, text }) {

	const handleClick = () => batch(() => {
		appLang.value = lang
		handleLangPopoverClose()
	})

    return <MenuItem onClick={handleClick} sx={{ ...appLang.value === lang && { backgroundColor: "primary.lighter" } }}>
		{text}
    </MenuItem>
}